import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAppStore } from './store/appStore';
import { authApi } from './services/api';
import LoginPage from './components/layout/LoginPage';
import AppShell from './components/layout/AppShell';
import ToastContainer from './components/layout/ToastContainer';

export default function App() {
  const { token, user, setAuth, logout, selectedCamera } = useAppStore();

  useEffect(() => {
    if (token && !user) {
      authApi.me()
        .then(res => setAuth(res.data, token))
        .catch(() => logout());
    }
  }, []);

  return (
    <BrowserRouter>
      {/* Global toasts — hidden when camera is selected (stream overlay takes over) */}
      {!selectedCamera && <ToastContainer />}
      <Routes>
        <Route path="/login" element={!token ? <LoginPage /> : <Navigate to="/" />} />
        <Route path="/*" element={token ? <AppShell /> : <Navigate to="/login" />} />
      </Routes>
    </BrowserRouter>
  );
}
